module.exports = __webpack_public_path__ + "img/fake-click.fd17e7e7.png";